import { combineReducers } from 'redux';

import { generateReducer } from './utils/generateReducer';

//universal
import { universalInitStates } from './data/universal/initStates';
//template
import { templateInitStates } from './data/template/initStates';
//set
import { setInitStates } from './data/set/initStates';
//page
import { pageInitStates } from './data/page/initStates';
//Organism
import { organismInitStates } from './data/organism/initStates';

// __________ object of universal reducers __________ //
export const initState_universal = {
	...universalInitStates,
};
// __________ object of template reducers __________ //
export const initState_template = {
	...templateInitStates,
};
// __________ object of set reducers __________ //
export const initState_set = {
	...setInitStates,
};
// __________ object of page reducers __________ //
export const initState_page = {
	...pageInitStates,
};
// __________ object of organism reducers __________ //
export const initState_organism = {
	...organismInitStates,
};

// __________ combine reducers __________ //
export const reducers = combineReducers({
	universal: combineReducers({ ...generateReducer(initState_universal, 'universal') }),
	template: combineReducers({ ...generateReducer(initState_template, 'template') }),
	set: combineReducers({ ...generateReducer(initState_set, 'set') }),
	page: combineReducers({ ...generateReducer(initState_page, 'page') }),
	organism: combineReducers({ ...generateReducer(initState_organism, 'organism') }),
});
